exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".teacherViewResponseModal{min-height:200px}.teacherViewResponseModal .studentInfoContainer{margin-bottom:20px}@media(min-width:1025px){.teacherViewResponseModal .studentInfoContainer{margin-left:80px}}@media(min-width:1025px){.teacherViewResponseModal .activityBox{padding-left:80px}}@media(min-width:1025px){.teacherViewResponseModal .commentBox{margin:0 80px}}@media(max-width:1024px){.teacherViewResponseModal .commentBox{margin-left:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/responses/teacher_view_response_modal.scss
// module id = 1540
// module chunks = 0